<template>
  <div class="acc-notif-item margin-top-m">
    <div class="large margin-bottom-xs">
      {{ INBOX.rewardsLabel }}
    </div>
    <p class="margin-bottom-s">
      <span v-if="rewardCard.expiringSoon">
        Shop now! Your {{ rewardCard.amount }} Star Money Reward is expiring on
        {{ rewardCard.expirationDate }}
      </span>
      <span v-else>
        {{ INBOX.rewardCards.congratsText }} {{ INBOX.rewardCards.rewardsEarned }} {{ rewardCard.amount }} {{ INBOX.rewardCards.redeemText }}
      </span>
    </p>
    <div class="margin-bottom-m">
      <NotificationsButton :page-url="INBOX.enrollRewards.rewardsPageUrl" :button-label="INBOX.enrollRewards.viewButtonLabel">
        {{ INBOX.viewButtonLabel }}
      </NotificationsButton>
    </div>
  </div>
</template>
<script setup>
import { INBOX } from 'config';
import NotificationsButton from './NotificationsButton';

defineProps({
  rewardCard: {
    type: Object,
    default: () => ({}),
  },
});
</script>
